import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { findIndex, indexOf } from 'ramda';

@Component({
  template: `
    <div class="form-group">
      <label *ngIf="!!label" >{{ label }}</label>
      <div class="input-group boxes">
        <div class="box r0 m-r-md" [ngClass]="{selected: index==0}" (click)="changeIndex(0)">&nbsp;</div>
        <div class="box r1 m-r-md" [ngClass]="{selected: index==1}" (click)="changeIndex(1)">&nbsp;</div>
        <div class="box r2" [ngClass]="{selected: index==2}" (click)="changeIndex(2)">&nbsp;</div>
      </div>
    </div>
  `,
  styles: [
    `
      .form-control {
        border: none;
        border-radius: 10px;
      }
      .boxes {
        display: flex;
      }
      .r0 {
        border-radius: 0 0 0 0;
      }
      .r1 {
        border-radius: 10px 0 10px 0;
      }
      .r2 {
        border-radius: 10px 10px 10px 10px;
      }

      .box {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border: 1px solid var(--border-color);
      }

      .selected {
        border: 1px solid var(--primary) !important;
      }
    `
  ],
  selector: 'input-radius'
})
export class InputRadiusComponent implements OnInit, OnDestroy {

  @Input('label') public label: string;

  @Output() public valueChange = new EventEmitter<string>();
  private _value: string;
  @Input('value')
  public get value(): string {
    return this._value;
  }
  public set value(v: string) {
    let next = indexOf(v, this.values);
    if (next < 0) next = 0;
    if (this.index !== next) {
      this.index = next;
      this._value = this.values[this.index];
      this.valueChange.emit(this._value);
    }
  }
  public index: number;

  private values = ['borderRadio1', 'borderRadio2', 'borderRadio3'];

  constructor() {}

  ngOnInit() {
  }

  ngOnDestroy(): void {}

  changeIndex(i: number) {
    this.value = this.values[i];
  }

  // // top-left top-right bottom-right bottom-left
  // getIndex(s: string) {
  //   const rs = s.split(' ');
  //   if (rs.length > 3) {
  //     if (rs[0] === '0' && rs[1] === '0' && rs[2] === '0' && rs[3] === '0') {
  //       return 0;
  //     } else if (rs[0] !== '0' && rs[1] === '0' && rs[2] !== '0' && rs[3] === '0') {
  //       return 1;
  //     } else if (rs[0] !== '0' && rs[1] !== '0' && rs[2] !== '0' && rs[3] !== '0') {
  //       return 2;
  //     }
  //   }
  //   return undefined;
  // }

  // fromIndex(i: number): string {
  //   switch(i) {
  //     case 0: return '0 0 0 0';
  //     case 1: return `${this.size}px 0 ${this.size}px 0`;
  //     case 2: return `${this.size}px ${this.size}px ${this.size}px ${this.size}px`;
  //     default: return '';
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-radius.component.ts